export default "__VITE_ASSET__7931e150__"